import React from 'react';
import App from '../containers/App';
import Password from '../containers/Password';
import { Route, Switch } from 'react-router-dom';
import store from '../store';

export default function Routes(props) {
	const state = store.getState();
	const isPasswordCorrect = state.security && state.security.isPasswordCorrect;
	return (
		<Switch>
			<Route path="/app" component={App} />
			<Route path="*" component={isPasswordCorrect ? App : Password} />
		</Switch>
	);
}



// WEBPACK FOOTER //
// ./src/root/Routes.js